<template>
  <v-app>
    <v-content>
      <v-container color="grey" fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-form @submit.prevent="tryToLogin">
              <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Logowanie</v-toolbar-title>

                  <v-spacer></v-spacer>

                  <v-toolbar-title>Karta Miejska</v-toolbar-title>

                  <v-btn to="home" flat icon>
                    <v-icon>mdi-home</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-alert v-model="showError" class="mt-3 mx-3" type="error" outline>{{ errorMessage }}</v-alert>

                <v-card-text>
                  <v-text-field
                    prepend-icon="person"
                    v-model="login"
                    name="login"
                    label="Login"
                    type="text"
                  ></v-text-field>

                  <v-text-field
                    prepend-icon="lock"
                    name="password"
                    label="Hasło"
                    id="password"
                    v-model="password"
                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                    :type="showPassword ? 'text' : 'password'"
                    hint="Minimum 8 znaków"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-card-text>

                <v-card-actions>
                  <router-link class="ma-2" :to="{ name: 'reset' }">Zapomniałem hasła</router-link>

                  <v-spacer></v-spacer>

                  <v-btn type="submit" color="primary">Login</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { ProfileType } from '@witkac/kartamiejska-shared';
// @vuese
// Formularz logowania
// @group Auth
export default {
  data() {
    return {
      showPassword: false,
      password: undefined,
      login: undefined,
      showError: false,
      errorMessage: undefined
    };
  },
  methods: {
    // @vuese
    // Metoda próbuje zalogować użytkownika po podanych danych
    tryToLogin() {
      const invalidPasswordMessage = 'Niepoprawny login lub hasło';

      this.$store
        .dispatch('auth/login', { login: this.login, password: this.password })
        .then(res => {
          const profileTarget = res.profile.partner ? 'placeSelect' : 'profile';
          const target = res.hasAllConsents ? profileTarget : 'termsCurrent';
          this.$router.push({ name: target });
        })
        .catch(error => {
          const message = error.message || error;
          if (message.includes(invalidPasswordMessage)) {
            this.errorMessage = invalidPasswordMessage;
          } else {
            this.errorMessage = message;
          }
        });
    }
  },
  watch: {
    errorMessage(val) {
      if (val) {
        this.showError = true;
      }
    },
    showError(val) {
      if (!val) {
        this.errorMessage = undefined;
      }
    }
  }
};
</script>
